import { acronisProductCodes as acronisBackupsProductCodes } from 'utility/acronisProductMap';

/**
 * Product codes of the add-ons a customer can order for a server. An ordered
 * cart item only counts as an add-on when its product code is in this list.
 */
export const ADD_ON_PRODUCT_CODES = [
	...acronisBackupsProductCodes,
	'AcronisEDR',
	'DDoS.Server.Protect',
	'ServerSecurity.Imunify360',
	'ServerSecurity.ThreatDown',
];

/**
 * Product codes of the security add-ons a customer can order for a server.
 */
export const SECURITY_ADD_ON_CODES = [
	'ServerSecurity.ThreatDown',
	'ServerSecurity.Imunify360',
	'AcronisEDR',
];

export default ADD_ON_PRODUCT_CODES;
